import React from 'react'

class Dashed extends React.PureComponent {
  render() {
    const {text} = this.props

    const dashInClass = (text !== undefined && text !== null && text.trim() !== "") ? "dashed_in" : ""

    return (
      <span className="dashed">
        <span className="dashed_out" />
        <span className={dashInClass}>{text}</span>
        <span className="dashed_out"/>
      </span>
    )
  }
}

export default Dashed



// WEBPACK FOOTER //
// ./src/js/components/typography/Dashed.js